import { Box, Theme, Typography } from "@mui/material"
import CustomTable from "../../investorOverview/common/customTable"
import { PortfolioHealthHeaderData } from "./tableHeaders"
import { PortfolioHealthTableBody } from "./tableBodies"
import { ComplianceProps } from "../portfolioAnalytics/compliance"
import { useEffect, useState } from "react"
import { PortfolioHealthResBody } from "../../../redux-store/types/analytics"
import { useDispatch, useSelector } from "react-redux"
import { RootStateType } from "../../../redux-store/reducers"
import { getPortfolioHealth } from "../../../redux-store/actions/analytics"
import { NO_DATA_AVAILABLE } from "../../../utils/constant"




export default function PortfolioHealth(props: ComplianceProps): JSX.Element {
    const { clientCode, portfolioId } = props;
    const [portfolioTableData, setPortfolioTableData] = useState<PortfolioHealthResBody>({} as PortfolioHealthResBody)
    const [portfolioDataLoading, setPortfolioDataLoading] = useState<boolean>(false);

    const dispatch = useDispatch();
    const { iwappRmId = "" } = useSelector((state: RootStateType) => state.id);

    const payload = {
        rmId: `${iwappRmId}`,
        clientCode,
        portfolioId,
        assetGroup: null
    }


    useEffect(() => {

        const fetchPortfolioHealthData = async () => {
            try {
                setPortfolioDataLoading(true);
                const portfolioDataRes = await (dispatch(getPortfolioHealth(payload)) as unknown as Promise<PortfolioHealthResBody>);
                setPortfolioTableData(portfolioDataRes);

                console.log('reer', portfolioDataRes)
            } catch (e) {
                console.log('E', e);
            } finally {
                setPortfolioDataLoading(false)
            }

        }
        fetchPortfolioHealthData();
    }, [])

    if (!portfolioDataLoading && !portfolioTableData?.isSuccess) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    position: "relative"
                }}
            >
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary,
                        textAlign: "center",
                        width: "100%"
                    })}
                >
                    {NO_DATA_AVAILABLE}
                </Typography>
            </Box>
        )
    }

    return (
        <Box >
            <CustomTable
                loadingRowsNum={5}
                isLoading={portfolioDataLoading}
                tableBody={
                    <PortfolioHealthTableBody
                        tableBodyData={portfolioTableData?.result || []}
                    />
                }
                tableData={portfolioTableData?.result || []}
                tableBodyLoaderRowCustomStyles={{
                    '& td:first-of-type': {
                        paddingLeft: "0px"
                    },
                }}
                tableHeaderData={PortfolioHealthHeaderData}
                tableHeadRowCustomStyles={{
                    '& th:first-of-type': {
                        paddingLeft: "0px",
                    }
                }}
                handleSort={() => { console.log("SORT") }}
                tableBodyCustomStyles={{
                    '& tr:last-child td': {
                        border: 0
                    }
                }}
                // order={sortingObj.order}
                // orderBy={sortingObj.orderBy}
                tableDataCount={portfolioTableData?.result?.length || 0}
                isPaginationVisible={false}
            />
        </Box>
    )
}